module.exports = __webpack_public_path__ + "static/psypop-fe45b94c58c8d646981a04b2074ca5ce.png";